import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Tools|CE Fee Vouchers';
type SPVoucherManagementLocs = 'SPVoucherManagementTitle' | 'SPVoucherManagementHeading';

export const spVoucherManagementLocDefs: LocDefs<SPVoucherManagementLocs> = {
	SPVoucherManagementTitle: {
		defaultValue: 'Continuing Education Fee Vouchers',
		description: 'Tab title for the continuing education fee vouchers page.',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Title',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
	SPVoucherManagementHeading: {
		defaultValue: 'Fee Vouchers',
		description: 'Heading for the continuing education fee vouchers page.',
		displayPath: `${dpRoot}|Heading`,
		displayType: 'Title',
		feature: HubFeature.CredentialContinuingEducationCredentialContinuingEducationVouchers,
		htmlAllowed: false,
		shared: false,
		portal: 'SP',
	},
};

export const spVoucherManagementLocs = MapLocKeys<SPVoucherManagementLocs>(
	spVoucherManagementLocDefs
);

export type SPVoucherManagementLocKeys = typeof spVoucherManagementLocs;
